export default {
    namespace: 'Resources',
    translations: {
        zh: {
            hero: {
                kicker: 'RESOURCES',
                title: '资源',
                description: '浏览核心人物与案例展示。'
            },
            items: [
                {
                    title: '核心人物',
                    linkLabel: '查看内容'
                },
                {
                    title: '案例展示',
                    linkLabel: '查看内容'
                }
            ]
        },
        en: {
            hero: {
                kicker: 'RESOURCES',
                title: 'Resources',
                description: 'Browse core people and case showcases.'
            },
            items: [
                {
                    title: 'Core People',
                    linkLabel: 'View'
                },
                {
                    title: 'Case Showcase',
                    linkLabel: 'View'
                }
            ]
        },
        ja: {
            hero: {
                kicker: 'RESOURCES',
                title: 'リソース',
                description: 'コアメンバーと事例紹介をご覧ください。'
            },
            items: [
                {
                    title: '核心人物',
                    linkLabel: '見る'
                },
                {
                    title: '案例展示',
                    linkLabel: '見る'
                }
            ]
        }
    }
};
